import type { AppRoutes } from "@app/appRouter.ts";
import { Link } from "@tanstack/react-router";

export type SectionTab = { label: string; to: AppRoutes };

export const enterpriseSectionTabs: SectionTab[] = [
  { label: "Visão geral", to: "/enterprises/overview" },
  { label: "Lojas", to: "/stores" },
];

export const peopleSectionTabs: SectionTab[] = [
  { label: "Funcionários", to: "/employees" },
  { label: "Adiantamentos", to: "/early-payments/requests" },
];

export function SectionTabs({ tabs }: { tabs: SectionTab[] }) {
  return (
    <nav className="flex gap-1 overflow-x-auto rounded-lg border border-border/60 bg-muted/35 p-1 w-fit max-w-full">
      {tabs.map((tab) => (
        <Link
          key={tab.to}
          to={tab.to}
          activeOptions={{ exact: true, includeSearch: false }}
          className="whitespace-nowrap rounded-md px-3 py-1.5 text-sm font-medium text-muted-foreground transition-colors hover:text-foreground [&.active]:bg-background [&.active]:text-foreground [&.active]:shadow-sm"
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
